import { render, staticRenderFns } from "./PixQrcode.vue?vue&type=template&id=85b27412&scoped=true&"
import script from "./PixQrcode.vue?vue&type=script&lang=js&"
export * from "./PixQrcode.vue?vue&type=script&lang=js&"
import style0 from "./PixQrcode.vue?vue&type=style&index=0&id=85b27412&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b27412",
  null
  
)

export default component.exports